import { apiurl } from '@/services/config'
export const userService = {
  login,
  logout,
  getme,
  changepass,
  resetpassword
}

async function changepass (pass) {
  // var data = JSON.stringify({ pass })
  // console.log(pass)
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    body: JSON.stringify(pass)
  }
  return fetch("https://api.irmastore.id/password/changepass", requestOptions)
    .then(handleResponse)
}

async function login (email, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  }

  return fetch(apiurl + '/auth/authenticate', requestOptions)
    .then(handleResponse)
    .then(data => {
      console.log(data)
      if (data.success) {
        localStorage.setItem('token', data.token)
        localStorage.setItem('user', JSON.stringify(data))
      }
      return data
    })
}

async function resetpassword (email) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  }
  return fetch(apiurl + '/auth/resetmypass', requestOptions)
    .then(handleResponse)
}

async function getme () {
  return fetch(apiurl + '/api/getme', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
}

function logout () {
  localStorage.clear()
}

function handleResponse (response) {
  console.log(response)
  return response.text().then(text => {
    const data = text && JSON.parse(text)

    if (!data.success) {
      if (response.status === 401) {
        console.log("CALL LOGOUT");
        localStorage.setItem('token',null);
        localStorage.clear();
        location.reload(true);
      }

      const error = (data && data.msg) || response.statusText

      return Promise.reject(error)
    }
    return data
  })
}
